import { ROUTES } from "@/shared/constants/routes";
import { RouteObject } from "react-router-dom";
import RiskAssessmentsPage from "../index";

export const InternalRiskRoutes: RouteObject[] = [
  {
    path: ROUTES.INTERNAL_RISK_ASSESSMENTS,
    Component: RiskAssessmentsPage,
  },
];
